import React, { useRef, useState } from "react";
import { Music } from "lucide-react";

const MusicPlayer = ({ data }) => {
  const audioRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const toggle = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (audio.paused) {
      const p = audio.play();
      if (p && typeof p.catch === "function") p.catch(() => {});
    } else {
      audio.pause();
    }
  };

  return (
    <section data-testid="music-player" className="space-y-5 text-center">
      <p className="eyebrow !text-[#A85C72]">დააჭირე</p>
      <div className="turntable">
        <button
          data-testid="music-toggle"
          onClick={toggle}
          className="mx-auto block rounded-full transition-transform hover:scale-[1.03] active:scale-95"
          aria-label="მუსიკის დაკვრა"
        >
          <div className={`vinyl-disc ${playing ? "spinning" : ""}`}>
            <div className="vinyl-label">
              <Music width={18} height={18} />
            </div>
          </div>
        </button>
        <div className={`tonearm ${playing ? "playing" : ""}`} aria-hidden="true">
          <span className="pivot" />
          <span className="arm" />
          <span className="head" />
        </div>
      </div>
      <div className="flex items-center justify-center gap-3">
        <div className={`eq ${playing ? "playing" : ""}`} aria-hidden="true">
          <span /><span /><span /><span /><span />
        </div>
        <p className="text-xs tracking-[0.18em] text-[#78716C]">{data.music.label}</p>
      </div>
      <audio
        ref={audioRef}
        loop
        preload="none"
        onPlay={() => setPlaying(true)}
        onPause={() => setPlaying(false)}
      >
        {data.music.sources.map((s, i) => (
          <source key={i} src={s.src} type={s.type} />
        ))}
      </audio>
    </section>
  );
};

export default MusicPlayer;
